<h2 mat-dialog-title>
  <ng-container *ngIf="!isTrial; else trialTitle">
    {{ acChangeEditionDialogConfig.title.key | translate }}
  </ng-container>
  <ng-template #trialTitle>
    <span>{{ acUpgradeEditionDialogConfig.title.key | translate }}</span>
  </ng-template>
</h2>
<mat-dialog-content>
  <div class="select-product-edition-text">
    {{ acChangeEditionDialogConfig.selectEdition.key | translate }}
  </div>

  <div class="app-info-edition-dropdown">
    <div class="app-name-container">
      <va-icon
        *ngIf="data.appIconUrl"
        [diameter]="32"
        [iconName]="data.appIconUrl"
        [iconUrl]="data.appIconUrl + '=s256'"
      ></va-icon>
      {{ data.appName }}
    </div>

    <mat-select
      class="edition-dropdown"
      [(value)]="selectedPlanType"
      #select="matSelect"
      (selectionChange)="planTypeChanged()"
    >
      <mat-select-trigger>{{ selectedPlanType }}</mat-select-trigger>
      <mat-option *ngFor="let planType of PlanTypeList" [value]="planType">
        <div class="edition-option">
          <div>
            {{ planType }}
          </div>
          <div class="badge" *ngIf="planType === currentPlanType && select.panelOpen">
            {{ acChangeEditionDialogConfig.current.key | translate }}
          </div>
        </div>
      </mat-option>
    </mat-select>
  </div>

  <div class="select-contacts-text">
    {{ acChangeEditionDialogConfig.selectContacts.key | translate }}
  </div>

  <mat-radio-group class="radio-group" [value]="selectedContactLimit" (change)="changeSelectedContactLimit($event)">
    <mat-radio-button
      class="radio-button"
      color="primary"
      *ngFor="let limit of ContactLimitList"
      [value]="limit"
      [disabled]="
        (selectedPlanType !== PlanType.Plus &&
          selectedPlanType !== PlanType.Lite &&
          limit === ContactLimit.limit1000) ||
        (selectedPlanType !== PlanType.Lite && limit === ContactLimit.limit500)
      "
    >
      <span class="contact-limit">
        <span>{{ limit }}</span>
        <span class="badge" *ngIf="limit === currentContactLimit">
          {{ acChangeEditionDialogConfig.current.key | translate }}
        </span>
      </span>
    </mat-radio-button>
  </mat-radio-group>

  <div class="confirmation">
    <mat-checkbox class="checkbox" color="primary" [(ngModel)]="confirmationCheckbox"></mat-checkbox>
    <ng-container *ngIf="!isTrial; else trialCheckbox">
      <span>{{ acChangeEditionDialogConfig.confirmation.key | translate }}</span>
    </ng-container>
    <ng-template #trialCheckbox>
      <span>{{ acUpgradeEditionDialogConfig.confirmation.key | translate }}</span>
    </ng-template>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button matDialogClose color="primary">
    {{ acChangeEditionDialogConfig.cancelButton.key | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="activateEditionForApp()"
    [disabled]="
      (!isTrial && currentContactLimit === selectedContactLimit && currentPlanType === selectedPlanType) ||
      !selectedContactLimit ||
      !confirmationCheckbox ||
      submitting
    "
  >
    <ng-container *ngIf="!submitting; else submit">
      <ng-container *ngIf="!isTrial; else trialButton">
        {{ acChangeEditionDialogConfig.changeEditionButton.key | translate }}
      </ng-container>
      <ng-template #trialButton>
        {{ acUpgradeEditionDialogConfig.upgradeEditionButton.key | translate }}
      </ng-template>
    </ng-container>
    <ng-template #submit>
      <mat-spinner [diameter]="24" [strokeWidth]="4"></mat-spinner>
    </ng-template>
  </button>
</mat-dialog-actions>
